import { api, IApprovalMatrixTypeApi } from "@/main/api/base";
import { KeyValue } from "@/main/models/common";
import { Result } from "@/main/models/common/resultResponse";
import { AxiosResponse } from "axios";

const baseRoute: string = "ApprovalMatrixType";

export class ApprovalMatrixTypeApi implements IApprovalMatrixTypeApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue>>> {
		return api.get(`${baseRoute}/domain`);
	}
}
